/** Lead status values (mirror of api LEAD_STATUSES) shown in the "Lead statuses" filter. */
export const LEAD_STATUS_OPTIONS = [
  ['NEW', 'New'], ['CONTACTED', 'Contacted'], ['QUALIFIED', 'Qualified'],
  ['PRESENTATION', 'Presentation'], ['FOLLOW_UP', 'Follow up'], ['QUOTED', 'Quoted'],
  ['BOOKED_APPOINTMENT', 'Booked appointment'], ['CALL_BACK', 'Call back'],
  ['NO_ANSWER', 'No answer'], ['NO_SHOW', 'No show'], ['NO_SALE', 'No sale'],
  ['SOLD', 'Sold'], ['NOT_INTERESTED', 'Not interested'], ['HOT', 'Hot'],
  ['RECYCLED', 'Recycled'], ['OPT_OUT', 'Opt out'], ['DNC', 'DNC'],
].map(([value, label]) => ({ value, label }));

/**
 * Dropdown options from the tenant's configured dispositions. Leads store the
 * disposition *slug* in `dispositionTags`, so the slug is the option value.
 * @param {Array<{slug?: string, label?: string, name?: string, color?: string}>} dispositions
 * @returns {Array<{value: string, label: string, color?: string}>}
 */
export function dispositionFilterOptions(dispositions = []) {
  return dispositions
    .filter((d) => d && (d.slug || d.name))
    .map((d) => ({ value: d.slug || d.name, label: d.label || d.name || d.slug, color: d.color }));
}

/**
 * Snapshot of the Leads filter state to persist as a saved search.
 * @param {object} s filter state
 * @returns {Record<string, string[]|string>}
 */
export function snapshotFilters(s) {
  const out = {};
  for (const k of ['vendors', 'states', 'timezones', 'statuses', 'dispositionTags', 'excludeDispositions']) {
    if (s[k]?.length) out[k] = s[k];
  }
  for (const k of ['onlyShow', 'onlyShowDays', 'onlyShowZip', 'onlyShowBirthYear', 'onlyShowBirthMonth', 'search', 'dateFrom', 'dateTo']) {
    if (s[k]) out[k] = s[k];
  }
  if (s.sort && s.sort !== '-createdAt') out.sort = s.sort;
  return out;
}

/**
 * Apply a saved snapshot through the page's setters (missing keys reset to empty).
 * @param {Record<string, *>} f saved filters
 * @param {Record<string, Function>} set setter map keyed like the snapshot
 */
export function applySavedFilters(f = {}, set) {
  for (const k of ['vendors', 'states', 'timezones', 'statuses', 'dispositionTags', 'excludeDispositions']) {
    set[k](Array.isArray(f[k]) ? f[k] : []);
  }
  for (const k of ['onlyShow', 'onlyShowDays', 'onlyShowZip', 'onlyShowBirthYear', 'onlyShowBirthMonth', 'search', 'dateFrom', 'dateTo']) {
    set[k](typeof f[k] === 'string' ? f[k] : '');
  }
  set.sort(typeof f.sort === 'string' ? f.sort : '-createdAt');
  set.page(1);
}
